/**
 * @name ifacsSvc
 * @desc Common security utility used for Login/User pages within iFastWeb Plus
 */
angular
    .module("iFAST.common")
    .factory("ifacsSvc",["$resource",
        function($resource) {
        "use strict";

            return $resource("ifacs/:method",
            {method: "@method"}, {
                forgotUid: {method:"POST", isArray:false},
                forgotPwd: {method:"POST", isArray: false},
                loginError: {method:"POST", isArray:false},
                logout: {method:"POST", isArray:false},
                resetPwd: {method:"POST", isArray: false},
                changePwd: {method:"POST", isArray: false},
				userSelfRegistration: {method:"POST", isArray: false},
				removeSalesRep: {method:"POST", isArray: false},
				addSalesRep: {method:"POST", isArray: false},
				verifyRecaptcha: {method:"POST", isArray: false}
            });
    }]);

angular
    .module("iFAST.common")
    .factory("iFastWebContextRootSvc", ["$location", function($location) {
        "use strict";
        var clientCode = "";
        if($location.host().indexOf("-") === -1) {
            clientCode = $location.host().substr(0, $location.host().indexOf("."));
        } else {
            clientCode = $location.host().substr(0, $location.host().indexOf("-"));
        }

        return {
            clientCode: clientCode
        };
    }]);

angular
    .module("iFAST.common")
    .factory("logoutSvc", ["$location", "$rootScope", "$cookies", "ifacsSvc", function($location, $rootScope, $cookies, ifacsSvc ) {
        "use strict";

        var passLogout = function (errCd, redirectUrl) {
            //console.log("Logout request is submitted.");

            return function(response) {
                var responseCode = response.code;
                if ((undefined === redirectUrl || null === redirectUrl) && undefined !== $rootScope.userInfo && null !== $rootScope.userInfo) {
                    redirectUrl = $rootScope.userInfo.redirectUrl;
                }
                var errParam = "";
                if (errCd) {
                    errParam = "?errCd=" + errCd;
                }

                if ("SUCCESS" === responseCode) {
                    //clear j_username  if the user didn't check "remember me" checkbox.
                    var saveUsername = $cookies.get("saveUsername"); // Returns string responses.
//                    var j_username = $cookies.j_username;

                    var JUSERNAME = "j_username",
                        NONSSOUSER = "nonSsoUser";

                    /* Code clean up note */
                    if (!saveUsername || undefined === saveUsername || "false" === saveUsername) {
                        delete $cookies.get(JUSERNAME);
                    }

                    delete $cookies.get(NONSSOUSER);

                    var loginUrl = $location.absUrl().substring(0, $location.absUrl().indexOf($location.path()));
                    var index = loginUrl.indexOf("/#");
                    if (0 < index) {
                        loginUrl = loginUrl.substring(0, index);
                    } else if(0 < loginUrl.indexOf("/?errCd")) {
                        loginUrl = loginUrl.substring(0, loginUrl.indexOf("/?errCd"));
                    }

                    if (undefined === redirectUrl || "" === redirectUrl.trim()) {
                        // Fix for ie8
                        location.href = loginUrl + errParam;
                    } else {
                        //relative url or absolute url
                        if ("/" === redirectUrl.charAt(0)) {
                            redirectUrl = loginUrl + redirectUrl;
                        }
                        location.href = redirectUrl + errParam;
                        // Fix for ie8
                    }
                }/* else {
                    //console.log("Logout failed");
                }*/
            };
        };

        var logout = function (errCd, redirectUrl) {
            ifacsSvc.logout({ method: "logout"})
                .$promise.then(passLogout(errCd, redirectUrl));
        };

        return {
            logout : logout
        };
    }]);


// WEBPACK FOOTER //
// ./WebContent/src/_common/services/shared/ifacs-service.js